import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AsyncSubject } from 'rxjs/AsyncSubject';
import { Observable } from 'rxjs';

import { RcsConnectorOdooProvider } from '../rcs-connector-odoo/rcs-connector-odoo';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { DraftServiceProvider } from '../draft-service/draft-service';

import { JobCommitPrototyp, OrderlinePrototyp, SchaetzlinePrototyp, WorklinePrototyp } from './job-commit.prototyp';
import { JobPrototyp } from '../../assets/shared/job.object';
import { StackService } from "../odoo/stack.service";
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class JobCommitProvider {

  private submoduls = {
    'orderline': 'orderline_ids',
    'schaetzline': 'schaetzline_ids',
    'workline': 'workline_ids'
  }

  constructor(
    private odoo: RcsConnectorOdooProvider,
    private db_service: RcsConnectorIndexDbProvider,
    private draft: DraftServiceProvider,
    private stack_s: StackService,
  ) {}

  public save(job){
    let observer = new AsyncSubject();
    let prototyp = this.create_prototyp(job);
    job.write_date = this.create_ISO_Date();
    this.db_service.update_record('jobs', job, job.id).subscribe(() => {
      this.db_service.get_record_by_key('login', 'user_login').subscribe(login => {
        this.draft.save_draft(job);
        this.stack_s.add(job.id, 3, 'update_record', [login, 'rcs.kdienst.auftrag', prototyp.id, prototyp]);
        if (this.stack_s.getNetworkState()) {
          this.stack_s.job_observer.pipe(takeUntil(observer)).subscribe((job2) => {
            console.log(job2.id, job.id, job2.id == job.id)
            if (job2.id == job.id) {
              observer.next(job2);
              observer.complete();
              console.log("STACK - SAVE", job2);
            }            
          });
        } else {
          observer.next(job);
          observer.complete();
          console.log("STACK - SAVE A", job);
        }
        console.log("SAVE")
        //observer.next(job);
        //observer.complete();
        /*this.stack_s.observer.subscribe(result => {
          if (result === job.id + '_' + 0){
            observer.error(true);
            observer.complete();
          }
          if (result === job.id + '_' + 3){
            this.update_job(job).subscribe((job) => {
              observer.next(job);
              observer.complete();  
            });
            
          }
        })*/
      })
    })
    return observer;
  }

  private create_ISO_Date(){
    Date.prototype.localISOString = function() {
      const pad = function(num) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };
    return this.getFullYear() +
      '-' + pad(this.getMonth() + 1) +
      '-' + pad(this.getDate()) +
      'T' + pad(this.getHours() - 1) +
      ':' + pad(this.getMinutes() + 1) + ':00'
    }
    let sync_date = new Date();
    let date_string = sync_date.localISOString().replace('T', ' ');
    var n = date_string.indexOf('+');
    return date_string.substring(0, n != -1 ? n : date_string.length).split("\\.")[0];
  }

  private create_prototyp(job){
    const prototyp = new JobCommitPrototyp();
    prototyp.id = job.id;
    prototyp.analyze_note = job.analyze_note;
    prototyp.dicht_pruef = job.dicht_pruef;
    prototyp.funktion_pruef = job.funktion_pruef;
    prototyp.finish_notes = job.finish_notes;
    prototyp.signature = job.signature;
    Object.assign(prototyp.orderline, job.orderline);
    prototyp.workline = job.workline;
    prototyp.schaetzline = job.schaetzline;
    this.create_sub_ids(prototyp);
    return prototyp;
  }

  private create_sub_ids(prototyp){
    for (let submodul in this.submoduls){
      let items = []
      for (let entry of prototyp[submodul]){
        let process_id: number = 1;
        let item_id = entry.id;
        if (entry.state){
          console.log(entry);
          if (entry.state_app == 'new'){
            process_id = 0;
          }
          if (entry.state == 'delete'){
            process_id = 2
          }
          if (entry.state == 'delete' && entry.state_app == 'new') {
            continue;
          }
        }
        items.push([process_id, item_id, this.create_submodul_prototyp(entry, submodul)]);
      }
      delete prototyp[submodul];
      prototyp[this.submoduls[submodul]] = items;
    }
  }

  private create_submodul_prototyp(item, submodul){
    if (submodul === 'orderline' ){
      const orderline_prototyp = new OrderlinePrototyp();
      orderline_prototyp.product_id = item.product_id[0];
      orderline_prototyp.product_uom = item.product_uom[0];
      orderline_prototyp.qty = item.qty;
      orderline_prototyp.qty_real = item.qty_real;
      return orderline_prototyp;
    }
    if (submodul === 'schaetzline' ){
      const schaetzline_prototyp = new SchaetzlinePrototyp();
      schaetzline_prototyp.dauer = item.dauer;
      schaetzline_prototyp.description = item.description;
      schaetzline_prototyp.name = item.name;
      if (item.order_id){
        schaetzline_prototyp.order_id = item.order_id[0];
      }
      return schaetzline_prototyp;
    }
    if (submodul === 'workline' ){
      const workline_prototyp = new WorklinePrototyp();
      workline_prototyp.bis = item.bis;
      workline_prototyp.von = item.von;
      workline_prototyp.dauer = item.dauer;
      workline_prototyp.description = item.description;
      workline_prototyp.name = item.name;
      workline_prototyp.monteur_id = item.monteur_id[0];
      return workline_prototyp;
    }
  }

  public signal_job_start(job){
    let observer = new AsyncSubject();
    this.db_service.update_record('jobs', job, job.id).subscribe(() => {
      this.db_service.get_record_by_key('login', 'user_login').subscribe(login => {
        this.stack_s.add(job.id, 2,'workflow_manipulations', [login, 'rcs.kdienst.auftrag', 'begin_work', job.id]);
        if (this.stack_s.getNetworkState()) {
          this.stack_s.job_observer.pipe(takeUntil(observer)).subscribe((job2) => {
            if (job2.id == job.id) {
              observer.next(job2);
              observer.complete();
              console.log("STACK - START", job2);
            }            
          });
        } else {
          observer.next(job);
          observer.complete();
          console.log("STACK - START A", job);
        }
        /*this.stack_s.observer.subscribe(result => {
          if (result === job.id + '_' + 0){
            observer.error(true);
            observer.complete();
          }
          if (result === job.id + '_' + 2){
            observer.next(true);
            observer.complete();
          }
        })*/
      })
    })
    return observer;
  }

  public signal_job_finish(job){
    let observer = new AsyncSubject();
    this.db_service.update_record('jobs', job, job.id).subscribe(() => {
      this.db_service.get_record_by_key('login', 'user_login').subscribe(login => {
        this.stack_s.add(job.id, 4,'workflow_manipulations', [login, 'rcs.kdienst.auftrag', 'finish_work', job.id])
        if (this.stack_s.getNetworkState()) {
          this.stack_s.job_observer.pipe(takeUntil(observer)).subscribe((job2) => {
            if (job2.id == job.id) {
              observer.next(job2);
              observer.complete();
              console.log("STACK - FIN", job2);
            }            
          });
        } else {
          observer.next(job);
          observer.complete();
          console.log("STACK - FIN A", job);
        }
      })
    })
    return observer;
  }

  public update_job(current_job):AsyncSubject<any>{
    let prototyp = new JobPrototyp();
    let result_guardian = new AsyncSubject();

    this.db_service.get_record_by_key('login', 'user_login').subscribe(
      login => {
        if (this.stack_s.getNetworkState()){
          this.odoo.get(login, prototyp, 'rcs.kdienst.auftrag', [["id", "=", current_job.id]], 0, 0, {"filter_my": 1}).subscribe(
            (response) => {
              let monteur_id = this.odoo.simple_search_read(login, 'rcs.kdienst.monteur', [["employee_id.login","=",login.username]], ["id"]);
              Observable.forkJoin.apply(this, [ response, monteur_id ]).subscribe( (data) => {
                console.log("UPDATE_JOB", data)
                let job = data[0]
                job['monteur'] = data[1].json().result[0];
                this.db_service.update_record('jobs', job, job.id).subscribe(
                  () => {
                    setTimeout(() => {
                      result_guardian.next(job);
                      result_guardian.complete();
                    }, 500);
                  }
                );
              });
            }
          )
        }else{
          this.db_service.update_record('jobs', current_job, current_job.id);
          result_guardian.next(current_job);
          result_guardian.complete();
        }
      }
    )
    return result_guardian;
  }
}



// WEBPACK FOOTER //
// ./src/providers/job-commit/job-commit.ts